/** =============================================================================
OWL SLIDER
============================================================================ */

$(document).ready(function()
{
  init_sliders();
});

// Pad a number with leading zeroes.
// Helper Funktion um einen Zahlen-Pager zu erstellen ( <- 1 2 3 4 -> )
function pad(n, len) {
  s = n.toString();
  if (s.length < len) {
    s = ('0000000000' + s).slice(-len);
  }

  return s;
}

function init_sliders() {

  gap = 32;
  pad = 32;

  rundj_slider00();
  rundj_slider01();
  rundj_slider02();
  rundj_slider03();
  rundj_slider04();
  rundj_slider05();
  rundj_sliderHero();
  rundj_sliderPolaroid();
}

// S L I D E R

function rundj_slider00() {

  rundj_slider00 = $('.m-slider--0');

  rundj_slider00.each(function() {

    $wrapper = $(this);
    var owl = $wrapper.find('>.owl-carousel');

    var owl_options = {

      loop: false,
      nav: false,
      items: 1,
      margin: 32,
      autoplay: false,
      autoplayTimeout: 2000,
      autoplayHoverPause: false,
      lazyLoad: true,
      dots: true,
      center: false,
      responsiveClass:true,

    };

    // Owl Slider initiieren
    owl.owlCarousel(owl_options);

  });

}

function rundj_slider01() {

  rundj_slider01 = $('.m-slider--1');

  rundj_slider01.each(function() {

    $wrapper = $(this);
    var owl = $wrapper.find('>.owl-carousel');

    var owl_options = {

      loop: false,
      nav: false,
      items: 1,
      margin: gap,
      stagePadding: pad,
      autoplay: false,
      autoplayTimeout: 2000,
      autoplayHoverPause: false,
      lazyLoad: true,
      dots: true,
      center: false,
      responsiveClass:true,

    };

    // Owl Slider initiieren
    owl.owlCarousel(owl_options);

  });

}

function rundj_slider02() {

  rundj_slider02 = $('.m-slider--2');

  rundj_slider02.each(function() {

    $wrapper = $(this);
    var owl = $wrapper.find('>.owl-carousel');

    var owl_options = {

      loop: false,
      nav: false,
      items: 2,
      margin: gap,
      autoplay: false,
      autoplayTimeout: 2000,
      autoplayHoverPause: false,
      lazyLoad: true,
      dots: false,
      center: false,
      responsiveClass:true,
      responsive:{
        0:{
          items: 1,
          stagePadding: pad,
          margin: gap,
        },
        640:{
          items: 2,
          stagePadding: pad,
          margin: gap,
        },
        1024:{
          items: 2,
          stagePadding: 0,
          margin: gap,
        },
      },
    };

    // Owl Slider initiieren
    owl.owlCarousel(owl_options);

  });

}

function rundj_slider03() {

  rundj_slider03 = $('.m-slider--3');

  rundj_slider03.each(function() {

    $wrapper = $(this);
    var owl = $wrapper.find('>.owl-carousel');

    var owl_options = {

      loop: false,
      nav: false,
      items: 3,
      margin: gap,
      autoplay: false,
      autoplayTimeout: 2000,
      autoplayHoverPause: false,
      lazyLoad: true,
      dots: false,
      center: false,
      responsiveClass:true,
      responsive:{
        0:{
          items: 1,
          stagePadding: pad,
          margin: gap,
        },
        640:{
          items: 2,
          stagePadding: pad,
          margin: gap,
        },
        1024:{
          items: 3,
          stagePadding: 0,
          margin: gap,
        },
      },
    };

    // Owl Slider initiieren
    owl.owlCarousel(owl_options);

  });

}

function rundj_slider04() {

  rundj_slider04 = $('.m-slider--4');

  rundj_slider04.each(function() {

    $wrapper = $(this);
    var owl = $wrapper.find('>.owl-carousel');

    var owl_options = {

      loop: false,
      nav: false,
      items: 4,
      margin: gap,
      autoplay: false,
      autoplayTimeout: 2000,
      autoplayHoverPause: false,
      lazyLoad: true,
      dots: false,
      center: false,
      responsiveClass:true,
      responsive:{
        0:{
          items: 1,
          stagePadding: pad,
          margin: gap,
        },
        640:{
          items: 2,
          stagePadding: pad,
          margin: gap,
        },
        1024:{
          items: 4,
          stagePadding: 0,
          margin: gap,
        },
      },
    };

    // Owl Slider initiieren
    owl.owlCarousel(owl_options);

  });

}

function rundj_slider05() {

  rundj_slider05 = $('.m-slider--5');

  rundj_slider05.each(function() {

    $wrapper = $(this);
    var owl = $wrapper.find('>.owl-carousel');

    var owl_options = {

      loop: false,
      nav: false,
      items: 5,
      margin: gap,
      autoplay: false,
      autoplayTimeout: 2000,
      autoplayHoverPause: false,
      lazyLoad: true,
      dots: false,
      center: false,
      responsiveClass:true,
      responsive:{
        0:{
          items: 1,
          stagePadding: pad,
          margin: gap,
        },
        640:{
          items: 3,
          stagePadding: pad,
          margin: gap,
        },
        1024:{
          items: 5,
          stagePadding: 0,
          margin: gap,
        },
      },
    };

    // Owl Slider initiieren
    owl.owlCarousel(owl_options);

  });

}

function rundj_sliderHero() {

  rundj_sliderHero = $('.m-slider--hero');

  rundj_sliderHero.each(function() {

    $wrapper = $(this);
    var owl = $wrapper.find('>.owl-carousel');

    var owl_options = {

      loop: false,
      nav: false,
      items: 2,
      margin: gap,
      autoplay: false,
      autoplayTimeout: 2000,
      autoplayHoverPause: false,
      lazyLoad: true,
      dots: false,
      center: false,
      responsiveClass:true,
      responsive:{
        0:{
          items: 1,
          stagePadding: pad,
          margin: gap,
        },
        640:{
          items: 2,
          stagePadding: pad,
          margin: gap,
        },
        1024:{
          items: 2,
          stagePadding: pad,
          margin: gap,
        },
      },
    };

    // Owl Slider initiieren
    owl.owlCarousel(owl_options);

  });

}

function rundj_sliderPolaroid() {

  rundj_sliderPolaroid = $('.m-slider--polaroid');

  rundj_sliderPolaroid.each(function() {

    $wrapper = $(this);
    var owl = $wrapper.find('>.owl-carousel');

    var owl_options = {

      loop: false,
      nav: false,
      items: 1,
      margin: 0,
      autoplay: false,
      autoplayTimeout: 2000,
      autoplayHoverPause: false,
      lazyLoad: true,
      dots: true,
      center: false,
      responsiveClass:true,
      onChange: callback,
	  autoHeight:true
    };

	$('.m-slider__polaroid--next').click(function() {
		owl.trigger('next.owl.carousel');
	});

    // Owl Slider initiieren
    owl.owlCarousel(owl_options);

    function callback(event) {
      var polaroids = event.item.count;
      // var polaroid = event.item.index;
      // console.log(polaroids,polaroid);
      var polaroid = Math.floor(Math.random() * polaroids + 1 );
      // console.log(polaroid);
      $('.m-slider__polaroid--image figure').hide();
      $('.m-slider__polaroid--image figure:nth-child('+ polaroid +')').show();
    }

  });

}